var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMedium = function SvgMedium(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M174.665 303c0-11-4.278-20.778-12.833-29.333l-82.5-99V160h258.5l197.999 436.335L710.001 160h245.666v14.667L884.166 242.5c-6.11 4.889-8.555 11.611-7.334 20.167v498.669c-1.22 8.555 1.225 15.275 7.334 20.164l69.666 67.831V864H605.497v-14.669l71.501-69.666c3.669-3.665 5.5-6.11 5.5-7.33 1.225-2.445 1.835-6.724 1.835-12.834V356.167L486.334 862.166h-27.503L225.999 356.167v339.168c-1.222 14.665 3.056 27.499 12.833 38.498l93.5 113.668v14.665h-264v-14.665l93.5-113.668c11-10.999 15.278-23.834 12.833-38.498V303z",
    fill: "currentColor"
  })));
};
export { SvgMedium as ReactComponent };
export default __webpack_public_path__ + "f6b8ade6b0b52627ae27aa983e5b2a8f.svg";